import * as yup from 'yup';

export const createBonusTransactionValidation = yup.object().shape({
  notesForBee: yup.string().required("Notes for Bee is required").min(4, "Notes for Bee must be at least 4 characters"),
  notesForAdmin: yup
      .string()
      .notRequired(),
  amount: yup.number()
  .transform(value => (isNaN(value) ? undefined : value)) 
  .min(0, "Amount must be a positive number")
  .moreThan(0, "Amount must be greater than zero")
  .required("Amount is required")
  .nullable(),
});